module.exports = __webpack_public_path__ + "static/bulette-cb7f2219aade6548555fb81937e1dda4.png";